import axios from 'axios'
import { editProjectError } from 'reduxStore/projects/actions'
import store, { history } from '../reduxStore'
import { authLogout } from '../reduxStore/auth'
import { getAuthToken, refreshAuthToken } from './authToken'
export const axiosInstance = axios.create({
  // You can set some default base URL, timeout, etc., if needed
  // ... other global settings
})

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = await getAuthToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

axiosInstance.interceptors.response.use(null, async (error) => {
  // A 401 usually means the token expired while the tab slept: refresh once and retry before logging out.
  if (error.response?.status === 401 && error.config && !error.config._authRetried) {
    const token = await refreshAuthToken()
    if (token) return axiosInstance({ ...error.config, _authRetried: true })
  }
  const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'An error occurred'

  // Optionally, you can also log the error
  const path = window.location.pathname
  const isLinked = path.includes('sample') || path.includes('link')
  // auth error will cause to log out
  if (error.response && error.response.status === 401 && !isLinked) {
    store.dispatch(editProjectError('Session expired. Please sign in again.'))
    authLogout()
    history.push('/signin')
  }

  //if 404 error, redirect to 404 page
  // else if (error.response && error.response.status === 404) {
  //   history.push('/not-found')
  // }
  // Dispatch the error to Redux store, unless the caller handles the failure itself or the device is offline (the
  // offline indicator says so, and saves are kept on the device)
  else if (!error.config?.skipGlobalError && (error.response || navigator.onLine)) {
    store.dispatch(editProjectError(message))
    // store.dispatch(undo())
  }

  return Promise.reject(error)
})
